/**
 * Northern Shopper — Community modal, geo-IP, cart attribute sync
 */
(function () {
	"use strict";

	var NS = window.NorthernShopper;
	if (!NS) return;

	var NOTIFY_STORAGE_KEY = "northernShopperSealiftNotify";

	function getAllowedCommunities() {
		if (NS.Community && typeof NS.Community.getAllowedKeys === "function") {
			return NS.Community.getAllowedKeys();
		}
		var keys = Object.keys(NS.communities || {});
		var entries = NS.commercialCommunities || [];
		var restrictToCommercial = !!(NS.commercialEnabled && entries.length);
		return keys.filter(function (k) {
			var c = NS.communities[k];
			if (!c) return false;
			if (!restrictToCommercial) return c.commercial !== true;
			if (c.commercial === false) return false;
			for (var i = 0; i < entries.length; i++) {
				var entry = entries[i];
				var value = entry;
				if (entry && typeof entry === "object") {
					value = entry.internal_name || entry.name || entry.handle || "";
					if (value && typeof value === "object") value = value.value || "";
				}
				if (!value) continue;
				value = String(value);
				if (value === k || value === c.internal_name || value === c.name || value === String(c.id || "")) return true;
			}
			return false;
		});
	}

	function populateCommunitySelect(select) {
		if (!select) return;
		select.innerHTML = "";
		getAllowedCommunities().forEach(function (key) {
			var c = NS.communities[key];
			var opt = document.createElement("option");
			opt.value = key;
			opt.textContent = c.name;
			select.appendChild(opt);
		});
		if (NS.Community.communityKey) {
			select.value = NS.Community.communityKey;
		}
	}

	function getModalCommunityKey(modal) {
		var select = modal.querySelector("#ns-community-select");
		return select ? select.value : NS.Community.communityKey;
	}

	function communityHasSealift(communityKey) {
		if (NS.Community && typeof NS.Community.communityHasSealiftLanding === "function") {
			return NS.Community.communityHasSealiftLanding(communityKey);
		}
		return false;
	}

	function getNotifyList() {
		try {
			var raw = localStorage.getItem(NOTIFY_STORAGE_KEY);
			return raw ? JSON.parse(raw) : [];
		} catch (e) {
			return [];
		}
	}

	function isNotifyingForCommunity(communityKey) {
		return getNotifyList().indexOf(communityKey) !== -1;
	}

	function setNotifyForCommunity(communityKey, enabled) {
		var list = getNotifyList().filter(function (key) {
			return key !== communityKey;
		});
		if (enabled) list.push(communityKey);
		localStorage.setItem(NOTIFY_STORAGE_KEY, JSON.stringify(list));
	}

	function setFreightOptionSelected(modal, freightType) {
		modal.querySelectorAll(".ns-custom-freight-option").forEach(function (option) {
			var input = option.querySelector('input[name="ns-freight-type"]');
			var selected = input && input.value === freightType;
			option.classList.toggle("is-selected", selected);
			if (input) input.checked = selected;
		});
	}

	function setPriceModeSelected(modal, showLanded) {
		modal.querySelectorAll("[data-ns-price-mode]").forEach(function (btn) {
			var isLanded = btn.getAttribute("data-ns-price-mode") === "landed";
			var active = showLanded ? isLanded : !isLanded;
			btn.classList.toggle("is-active", active);
			btn.setAttribute("aria-pressed", active ? "true" : "false");
		});
	}

	function getAutoVoyageId(communityKey) {
		var voyages = NS.Community.getVoyagesForCommunity(communityKey);
		if (!voyages.length) return null;
		var currentId = NS.Community.sealiftVoyageId;
		var hasCurrent = voyages.some(function (v) {
			return String(v.id) === String(currentId);
		});
		return hasCurrent ? currentId : voyages[0].id;
	}

	function syncModalSealiftLandings(modal, communityKey) {
		if (!communityHasSealift(communityKey)) return;
		var voyageId = getAutoVoyageId(communityKey);
		if (voyageId) {
			NS.sealiftLandings = NS.Community.getVoyageLandings(voyageId);
		}
	}

	function updateNotifyUI(modal, communityKey) {
		var notifyBtn = modal.querySelector("[data-ns-sealift-notify]");
		var notifyBadge = modal.querySelector("[data-ns-sealift-notify-badge]");
		var subscribed = isNotifyingForCommunity(communityKey);

		if (notifyBtn) {
			var labelOn = notifyBtn.querySelector('[data-ns-notify-state="on"]');
			var labelOff = notifyBtn.querySelector('[data-ns-notify-state="off"]');
			var iconOff = notifyBtn.querySelector(".ns-custom-sealift-notify__icon--off");
			var iconOn = notifyBtn.querySelector(".ns-custom-sealift-notify__icon--on");
			notifyBtn.classList.toggle("is-active", subscribed);
			notifyBtn.setAttribute("aria-pressed", subscribed ? "true" : "false");
			if (labelOn) labelOn.hidden = !subscribed;
			if (labelOff) labelOff.hidden = subscribed;
			if (iconOff) iconOff.hidden = subscribed;
			if (iconOn) iconOn.hidden = !subscribed;
		}

		if (notifyBadge) {
			notifyBadge.hidden = !subscribed;
			notifyBadge.setAttribute("aria-hidden", subscribed ? "false" : "true");
		}
	}

	function updateFreightUI(modal) {
		var communityKey = getModalCommunityKey(modal);
		var hasSealift = communityHasSealift(communityKey);
		var sealiftOption = modal.querySelector("[data-ns-freight-sealift]");
		var notifyWrap = modal.querySelector("[data-ns-sealift-notify-wrap]");
		var sealiftInput = sealiftOption ? sealiftOption.querySelector('input[value="sealift"]') : null;

		if (sealiftOption) {
			sealiftOption.classList.toggle("is-disabled", !hasSealift);
		}
		if (sealiftInput) {
			sealiftInput.disabled = !hasSealift;
		}
		if (notifyWrap) {
			notifyWrap.hidden = hasSealift;
			notifyWrap.classList.toggle("is-hidden", hasSealift);
		}

		var unavailableText = modal.querySelector("[data-ns-sealift-unavailable-text]");
		if (unavailableText) {
			unavailableText.hidden = hasSealift;
		}

		updateNotifyUI(modal, communityKey);

		var freightEl = modal.querySelector('input[name="ns-freight-type"]:checked');
		if (!hasSealift && freightEl && freightEl.value === "sealift") {
			setFreightOptionSelected(modal, "air");
		}

		if (hasSealift) {
			syncModalSealiftLandings(modal, communityKey);
		}
	}

	function openModal() {
		var modal = document.getElementById("ns-community-modal");
		if (!modal) return;
		populateCommunitySelect(modal.querySelector("#ns-community-select"));

		var freightType = NS.Community.freightType;
		if (freightType === "sealift" && !communityHasSealift(NS.Community.communityKey)) {
			freightType = "air";
		}
		setFreightOptionSelected(modal, freightType);
		setPriceModeSelected(modal, NS.showLanded !== false);
		updateFreightUI(modal);

		modal.hidden = false;
		modal.setAttribute("aria-hidden", "false");
		document.body.classList.add("ns-custom-modal-open");
	}

	function closeModal() {
		var modal = document.getElementById("ns-community-modal");
		if (!modal) return;
		modal.hidden = true;
		modal.setAttribute("aria-hidden", "true");
		document.body.classList.remove("ns-custom-modal-open");
	}

	function handleSubmit(e) {
		e.preventDefault();
		var modal = document.getElementById("ns-community-modal");
		var communityKey = modal.querySelector("#ns-community-select").value;
		var freightEl = modal.querySelector('input[name="ns-freight-type"]:checked');
		var freightType = freightEl ? freightEl.value : "air";
		if (freightType === "sealift" && !communityHasSealift(communityKey)) {
			freightType = "air";
		}
		var voyageId = freightType === "sealift" ? getAutoVoyageId(communityKey) : null;
		var landedBtn = modal.querySelector('[data-ns-price-mode="landed"]');
		if (landedBtn) {
			NS.Pricing.setShowLanded(landedBtn.classList.contains("is-active"));
		}
		NS.Community.setCommunity(communityKey, freightType, voyageId)
			.catch(function () { })
			.then(closeModal);
	}

	function bindModalInteractions(modal) {
		modal.querySelectorAll(".ns-custom-freight-option").forEach(function (option) {
			option.addEventListener("click", function (e) {
				if (option.classList.contains("is-disabled")) {
					e.preventDefault();
					return;
				}
				var input = option.querySelector('input[name="ns-freight-type"]');
				if (!input || input.disabled) return;
				setFreightOptionSelected(modal, input.value);
				if (input.value === "sealift") {
					syncModalSealiftLandings(modal, getModalCommunityKey(modal));
				}
				updateFreightUI(modal);
			});
		});

		modal.querySelectorAll("[data-ns-price-mode]").forEach(function (btn) {
			btn.addEventListener("click", function () {
				var showLanded = btn.getAttribute("data-ns-price-mode") === "landed";
				setPriceModeSelected(modal, showLanded);
			});
		});

		var communitySelect = modal.querySelector("#ns-community-select");
		if (communitySelect) {
			communitySelect.addEventListener("change", function () {
				updateFreightUI(modal);
			});
		}

		var notifyBtn = modal.querySelector("[data-ns-sealift-notify]");
		if (notifyBtn) {
			notifyBtn.addEventListener("click", function () {
				var communityKey = getModalCommunityKey(modal);
				var subscribed = isNotifyingForCommunity(communityKey);
				setNotifyForCommunity(communityKey, !subscribed);
				updateFreightUI(modal);
			});
		}
	}

	function initGeoIP() {
		if (localStorage.getItem("northerShopperCommunity")) return;
		window.geoip = function (json) {
			if (!json || !json.city) return;
			var keys = getAllowedCommunities();
			for (var i = 0; i < keys.length; i++) {
				var c = NS.communities[keys[i]];
				if (c.name && c.name.toLowerCase() === json.city.toLowerCase()) {
					NS.Community.setCommunity(keys[i], "air", null, true).catch(function () { });
					return;
				}
				var alts = c.alternate_names || [];
				for (var j = 0; j < alts.length; j++) {
					if (alts[j] && alts[j].toLowerCase() === json.city.toLowerCase()) {
						NS.Community.setCommunity(keys[i], "air", null, true).catch(function () { });
						return;
					}
				}
			}
		};
		var script = document.createElement("script");
		script.src = "https://get.geojs.io/v1/ip/geo.js";
		script.async = true;
		script.defer = true;
		document.body.appendChild(script);
	}

	function bindUI() {
		document.querySelectorAll("[data-ns-open-community-modal]").forEach(function (btn) {
			btn.addEventListener("click", function (e) {
				e.preventDefault();
				var drawer = document.getElementById("MenuDrawer");
				if (drawer && typeof drawer.hide === "function") {
					drawer.hide();
				}
				openModal();
			});
		});
		var modal = document.getElementById("ns-community-modal");
		if (!modal) return;
		modal.querySelectorAll("[data-ns-close-modal]").forEach(function (btn) {
			btn.addEventListener("click", closeModal);
		});
		var form = modal.querySelector("#ns-community-form");
		if (form) form.addEventListener("submit", handleSubmit);
		modal.addEventListener("click", function (e) {
			if (e.target === modal) closeModal();
		});
		document.addEventListener("keydown", function (e) {
			if (e.key === "Escape" && !modal.hidden) closeModal();
		});
		bindModalInteractions(modal);
	}

	function getSectionsToBundle() {
		var sections = [];
		document.documentElement.dispatchEvent(
			new CustomEvent("cart:grouped-sections", { bubbles: true, detail: { sections: sections } })
		);
		return sections;
	}

	function publishCartUpdate(cart) {
		if (window.FoxTheme && FoxTheme.pubsub && cart) {
			FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
		}
	}

	function setLineSubVisibility(enabled) {
		document.querySelectorAll("[data-ns-line-sub]").forEach(function (el) {
			el.hidden = !enabled;
		});
		document.querySelectorAll("[data-ns-subs-note]").forEach(function (el) {
			el.hidden = !enabled;
		});
	}

	function setCheckoutBlocked(blocked) {
		document.querySelectorAll("#checkout, button[name='checkout'], [type='submit'][name='checkout']").forEach(function (btn) {
			btn.disabled = !!blocked;
			btn.setAttribute("aria-disabled", blocked ? "true" : "false");
			btn.classList.toggle("ns-custom-checkout--blocked", !!blocked);
			btn.querySelectorAll(".ns-custom-checkout__blocked-icon").forEach(function (icon) {
				icon.hidden = !blocked;
			});
		});
	}

	NS.setCheckoutBlocked = setCheckoutBlocked;

	var auroraSavedValue = String((NS.cartAttributes && NS.cartAttributes.aurora_rewards_number) || "").trim();
	var auroraSaveRequest = 0;

	function saveAuroraValue(value) {
		return NS.fetch.cartUpdate({ attributes: { "Aurora Rewards Number": value || "" } });
	}

	function syncAuroraCheckmark(input) {
		if (!input) return;
		var current = String(input.value || "").trim();
		var saved = String(auroraSavedValue || "").trim();
		var show = saved !== "" && current === saved;
		var root = input.closest("cart-addon-modal");
		var checks = [];
		if (root) {
			var opener = root.previousElementSibling;
			if (opener) checks = opener.querySelectorAll("[data-ns-aurora-check]");
		} else {
			root = input.closest(".cart__addon");
			if (root) checks = root.querySelectorAll("[data-ns-aurora-check]");
		}
		Array.prototype.forEach.call(checks, function (mark) {
			mark.hidden = !show;
		});
	}

	function applyAuroraSaved(saved, sentValue) {
		auroraSavedValue = String(saved || "").trim();
		if (!NS.cartAttributes) NS.cartAttributes = {};
		NS.cartAttributes.aurora_rewards_number = auroraSavedValue;
		var sent = String(sentValue || "").trim();
		document.querySelectorAll("[data-ns-aurora-input]").forEach(function (input) {
			var current = String(input.value || "").trim();
			var editing = input.dataset.nsAuroraDirty === "1" && current !== sent;
			if (!editing && document.activeElement !== input) {
				input.value = auroraSavedValue;
				delete input.dataset.nsAuroraDirty;
			} else if (current === sent) {
				delete input.dataset.nsAuroraDirty;
			}
			syncAuroraCheckmark(input);
		});
	}

	function persistAuroraValue(value) {
		var payload = String(value || "").trim();
		if (payload === String(auroraSavedValue || "").trim()) {
			document.querySelectorAll("[data-ns-aurora-input]").forEach(syncAuroraCheckmark);
			return Promise.resolve();
		}
		var requestId = ++auroraSaveRequest;
		return saveAuroraValue(payload).then(function (cart) {
			if (requestId !== auroraSaveRequest) return cart;
			var saved = payload;
			if (cart && cart.attributes && Object.prototype.hasOwnProperty.call(cart.attributes, "Aurora Rewards Number")) {
				saved = cart.attributes["Aurora Rewards Number"] || "";
			}
			applyAuroraSaved(saved, payload);
			return cart;
		});
	}

	function normalizedFlag(value) {
		if (value == null) return "";
		return String(value).trim().toLowerCase();
	}

	function orderAllowsSubstitutions(value) {
		return normalizedFlag(value) === "yes";
	}

	function subsOptOutKey() {
		return "northernShopperSubsOptOut:" + (NS.cartToken || "cart");
	}

	function readSubsOptOut() {
		try {
			return localStorage.getItem(subsOptOutKey()) === "1";
		} catch (e) {
			return false;
		}
	}

	function writeSubsOptOut(optedOut) {
		try {
			if (optedOut) localStorage.setItem(subsOptOutKey(), "1");
			else localStorage.removeItem(subsOptOutKey());
		} catch (e) { }
	}

	function resolveAllowChecked() {
		var attr = NS.cartAttributes && NS.cartAttributes.allow_substitutions;
		if (orderAllowsSubstitutions(attr)) return true;
		if (readSubsOptOut()) return false;
		if (normalizedFlag(attr) !== "") return false;
		return NS.allowSubstitutions !== false;
	}

	function syncAllowToggles(enabled) {
		setLineSubVisibility(enabled);
		document.querySelectorAll("[data-ns-allow-substitutions]").forEach(function (other) {
			other.checked = enabled;
		});
	}

	var subsRequestId = 0;

	function updateAllowSubstitutions(enabled) {
		var requestId = ++subsRequestId;
		writeSubsOptOut(!enabled);
		NS._subsSynced = true;
		if (!NS.cartAttributes) NS.cartAttributes = {};
		NS.cartAttributes.allow_substitutions = enabled ? "yes" : "";
		syncAllowToggles(enabled);
		return NS.fetch
			.cartUpdate({
				attributes: { allow_substitutions: enabled ? "yes" : "" },
				sections: getSectionsToBundle(),
			})
			.then(
				function (cart) {
					if (requestId !== subsRequestId) return cart;
					var next = cart && cart.attributes ? cart.attributes.allow_substitutions : "";
					NS.cartAttributes.allow_substitutions = next || "";
					publishCartUpdate(cart);
					return cart;
				},
				function (err) {
					if (requestId !== subsRequestId) return;
					throw err;
				}
			);
	}

	function linePropertiesForChange(item, allowLine) {
		var props = {};
		var source = (item && item.properties) || {};
		Object.keys(source).forEach(function (key) {
			if (key === "_allowSubstitutions" || key === "_no_substitutions" || key === "allow_substitutions") return;
			if (source[key] != null && source[key] !== "") props[key] = source[key];
		});
		if (normalizedFlag(source.allow_substitutions) === "no") {
			props.allow_substitutions = "no";
		} else {
			// /cart/change.js cannot clear properties to {} once set, so re-enabling
			// must write an explicit "false" instead of dropping the key.
			props._no_substitutions = allowLine ? "false" : "true";
		}
		return props;
	}

	function updateLineSubstitution(toggle) {
		if (!toggle || toggle.dataset.nsLineSubBusy === "1") return Promise.resolve();
		var lineKey = toggle.getAttribute("data-ns-line-key");
		var lineIndex = parseInt(toggle.getAttribute("data-ns-line-index"), 10);
		var quantity = parseInt(toggle.getAttribute("data-ns-line-quantity"), 10) || 1;
		if (!lineKey && !lineIndex) return Promise.resolve();
		if (toggle.getAttribute("data-ns-line-sub-locked") === "true") return Promise.resolve();

		// Read before any await. Drawer re-renders can replace this node mid-request.
		var allowLine = !!toggle.checked;
		var cartUrl = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/") + "cart.js";
		var changeUrl =
			(window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_change_url) ||
			(window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/") + "cart/change.js";

		var root = toggle.closest ? toggle.closest("[data-ns-line-sub]") : null;
		toggle.dataset.nsLineSubBusy = "1";
		toggle.disabled = true;
		if (root) root.classList.add("is-busy");

		return fetch(cartUrl, { headers: { Accept: "application/json" } })
			.then(function (r) {
				return r.json();
			})
			.then(function (cart) {
				var item = null;
				var items = cart.items || [];
				for (var i = 0; i < items.length; i++) {
					if ((lineKey && items[i].key === lineKey) || (!lineKey && i + 1 === lineIndex)) {
						item = items[i];
						lineIndex = i + 1;
						break;
					}
				}
				if (!item && lineIndex > 0 && items[lineIndex - 1]) {
					item = items[lineIndex - 1];
				}
				if (!item) throw new Error("Cart line not found");

				// /cart/change.js replaces the whole properties object.
				var body = {
					line: lineIndex || 1,
					quantity: item.quantity || quantity,
					properties: linePropertiesForChange(item, allowLine),
					sections: getSectionsToBundle(),
				};
				return fetch(changeUrl, {
					method: "POST",
					headers: { "Content-Type": "application/json", Accept: "application/json" },
					body: JSON.stringify(body),
				}).then(function (r) {
					return r.json().then(function (data) {
						if (!r.ok || data.status === 422 || data.errors) {
							throw new Error((data && data.description) || data.message || "Cart line update failed");
						}
						return data;
					});
				});
			})
			.then(function (parsedState) {
				publishCartUpdate(parsedState);
			})
			.catch(function (err) {
				console.error("[NorthernShopper] Line substitution update failed", err);
				toggle.checked = !toggle.checked;
			})
			.finally(function () {
				delete toggle.dataset.nsLineSubBusy;
				if (root) root.classList.remove("is-busy");
				if (toggle.isConnected && toggle.getAttribute("data-ns-line-sub-locked") !== "true") toggle.disabled = false;
			});
	}

	// Delegated so a cart-drawer section swap cannot drop the listener.
	// The drawer is transformed and clips the theme's 0×0 switch, so a label
	// click there often never checks the input or fires change.
	function bindLineSubstitutionEvents() {
		document.addEventListener("change", function (event) {
			var toggle = event.target;
			if (!toggle || !toggle.matches || !toggle.matches("[data-ns-line-sub-toggle]")) return;
			updateLineSubstitution(toggle);
		});

		document.addEventListener("click", function (event) {
			var target = event.target;
			if (!target || !target.closest) return;
			var label = target.closest(".ns-custom-line-sub__label");
			if (!label) return;
			var root = label.closest("[data-ns-line-sub]");
			var toggle = root && root.querySelector("[data-ns-line-sub-toggle]");
			if (!toggle || toggle.disabled || toggle.getAttribute("data-ns-line-sub-locked") === "true") return;
			if (target === toggle) return;
			event.preventDefault();
			toggle.checked = !toggle.checked;
			updateLineSubstitution(toggle);
		});
	}

	function initCartFeatures() {
		document.querySelectorAll("[data-ns-aurora-input]").forEach(function (auroraInput) {
			if (!auroraInput.value && NS.auroraRewardsNumber) {
				auroraInput.value = NS.auroraRewardsNumber;
			}
			syncAuroraCheckmark(auroraInput);
			if (auroraInput.dataset.nsBound) return;
			auroraInput.dataset.nsBound = "1";

			auroraInput.addEventListener("input", function () {
				var current = String(auroraInput.value || "").trim();
				if (current === String(auroraSavedValue || "").trim()) delete auroraInput.dataset.nsAuroraDirty;
				else auroraInput.dataset.nsAuroraDirty = "1";
				syncAuroraCheckmark(auroraInput);
			});
			auroraInput.addEventListener("change", function () {
				persistAuroraValue(auroraInput.value).catch(function () {
					syncAuroraCheckmark(auroraInput);
				});
			});
		});

		// Persist customer metafield into cart attribute when cart attr is empty.
		if (
			NS.auroraRewardsNumber &&
			!(NS.cartAttributes && NS.cartAttributes.aurora_rewards_number) &&
			!NS._auroraSynced
		) {
			NS._auroraSynced = true;
			persistAuroraValue(NS.auroraRewardsNumber).catch(function () { });
		}

		// Re-rendered sections come back from Liquid with the default visibility, which
		// cannot see the shopper's opt-out. Always re-apply the resolved state, even when
		// the cart-level toggle node itself survived the update.
		var allowChecked = resolveAllowChecked();
		setLineSubVisibility(allowChecked);

		document.querySelectorAll("[data-ns-allow-substitutions]").forEach(function (subToggle) {
			if (subToggle.dataset.nsBound) return;
			subToggle.dataset.nsBound = "1";

			subToggle.checked = allowChecked;

			subToggle.addEventListener("change", function () {
				var enabled = subToggle.checked;
				var previous = enabled ? "" : "yes";
				updateAllowSubstitutions(enabled).catch(function (err) {
					console.error("[NorthernShopper] Allow substitutions update failed", err);
					writeSubsOptOut(enabled);
					if (!NS.cartAttributes) NS.cartAttributes = {};
					NS.cartAttributes.allow_substitutions = previous;
					syncAllowToggles(!enabled);
				});
			});
		});

		if (!NS._subsSynced) {
			NS._subsSynced = true;
			var stored = NS.cartAttributes && NS.cartAttributes.allow_substitutions;
			var storedFlag = normalizedFlag(stored);
			if (storedFlag === "yes") {
				if (stored !== "yes") updateAllowSubstitutions(true).catch(function () { });
			} else if (storedFlag !== "") {
				updateAllowSubstitutions(false).catch(function () { });
			} else if (!readSubsOptOut() && NS.allowSubstitutions !== false) {
				updateAllowSubstitutions(true).catch(function () { });
			}
		}

		document.querySelectorAll("#checkout, button[name='checkout'], [type='submit'][name='checkout']").forEach(function (checkoutBtn) {
			if (checkoutBtn.dataset.nsBound) return;
			checkoutBtn.dataset.nsBound = "1";
			checkoutBtn.addEventListener("click", function (e) {
				if (checkoutBtn.disabled || checkoutBtn.classList.contains("ns-custom-checkout--blocked")) {
					e.preventDefault();
					e.stopPropagation();
					return;
				}
				var minWarn = document.getElementById("ns-minimum-order-warning");
				if (minWarn && !minWarn.hidden) {
					e.preventDefault();
					e.stopPropagation();
					minWarn.scrollIntoView({ behavior: "smooth", block: "nearest" });
					return;
				}
			});
		});

		if (NS.Pricing && typeof NS.Pricing.updateMinimumWarnings === "function") {
			NS.Pricing.updateMinimumWarnings();
		}
	}

	bindLineSubstitutionEvents();

	document.addEventListener("DOMContentLoaded", function () {
		bindUI();
		initGeoIP();
		initCartFeatures();
	});

	document.addEventListener("ns:community:changed", function () {
		NS.Pricing.applyProductVisibility();
	});

	// The theme swaps #MainCart / #CartDrawerBody innerHTML inside its own cartUpdate
	// subscriber. Each swap constructs a new <cart-items>, which re-subscribes at the end
	// of the pubsub list, so from the second update on our subscriber would run before
	// the swap and bind nodes that are about to be discarded. Defer to a microtask so
	// init always sees the freshly rendered DOM, and also listen for the theme's
	// post-swap "cart:updated" event as a belt-and-braces hook.
	function scheduleCartFeaturesInit() {
		Promise.resolve().then(initCartFeatures);
	}

	if (typeof FoxTheme !== "undefined" && FoxTheme.pubsub) {
		FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, scheduleCartFeaturesInit);
	}
	document.addEventListener("cart:updated", scheduleCartFeaturesInit);
})();
